import React, { useImperativeHandle, useRef, forwardRef, useEffect } from "react";

export interface BuzzHandle {
  play: () => void;
}

const Buzz = forwardRef<BuzzHandle>((_, ref) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleAudioPlay = () => {
    console.log("Buzz");
  };

  const handleAudioError = (err: unknown) => {
    console.warn("Buzzer error:", err);
  };

  const clearStopTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    return () => {
      clearStopTimer();
      audio?.pause();
    };
  }, []);

  useImperativeHandle(ref, () => ({
    play: () => {
      const audio = audioRef.current;
      if (!audio) return;

      // Restart from the beginning for a crisp single buzz.
      clearStopTimer();
      audio.pause();
      audio.currentTime = 0;

      audio.play().catch(handleAudioError);

      // Auto-stop after 1 second to avoid long playback overlap.
      timeoutRef.current = setTimeout(() => {
        audio.pause();
        audio.currentTime = 0;
      }, 1000);
    },
  }));

  return (
    <audio
      ref={audioRef}
      src="/notification.mp3"
      preload="auto"
      onPlay={handleAudioPlay}
      onError={handleAudioError}
    />
  );
});

export default Buzz;
